import { render, staticRenderFns } from "./ConctentTabMulta.vue?vue&type=template&id=6750d152&"
import script from "./ConctentTabMulta.vue?vue&type=script&lang=js&"
export * from "./ConctentTabMulta.vue?vue&type=script&lang=js&"
import style0 from "./ConctentTabMulta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports